import { gql } from '@apollo/client';

export const GET_EQUIPMENT_DETAILS_BY_ID = gql`
  query GetEquipmentDetailsById($id: ID!) {
    equipment: equipmentById(id: $id) {
      equipmentId
      year
      make
      model
      stockId
      serialNumberVin
      newUsed
      mileage
      tradeInValue
      amountOwedOnTradeIn
      classType
      truckClass
      assetTypeStr
      type
      style
      hours
      additionalDescription
      wholesaleCost
      totalWholesaleCost
      retailPrice
      discountType
      discountValue
      quantity
      createdDateTime
      modifiedDateTime
      attachments
      specs
      assets {
        id
        source
        type
        createdDateTime
      }
      inventoryItem {
        inventoryId
        status
        condition
      }
    }
  }
`;
